<!-- eslint-disable vue/script-indent -->
<script lang="ts" setup>
export interface SearchFormProps {
    action: VNuxtLinkTo
    controlName: string
    placeholder: string
    submit: boolean
    navigateOnSearch?: boolean
}

const { $t } = useNuxtApp()
const props = withDefaults(defineProps<SearchFormProps>(), {
    navigateOnSearch: true,
})
const router = useRouter()
const route = useRoute()
const control = ref<HTMLInputElement>()
const slots = useSlots()
const hasSlots = computed<boolean>((): boolean => {
    if (typeof slots.default !== 'function') return false
    if (slots.default().length === 0) return false
    return true
})
const slot = ref<any>()
const cta = $t('Hľadať')
const { data, sendEvent } = useTracker()

const handleSubmit = (e: Event): boolean | void => {
    sendEvent({
        data: {
            ...data,
            title: cta,
            event: 'submit',
        },
    })

    // submit form?
    if (props.submit) return true
    // prevent default
    e.preventDefault()
    // get value => from slots get input value, from component you ref
    // const value = hasSlots ?
    if (props.navigateOnSearch) {
        const value: string | undefined = hasSlots
            ? ((e.target as HTMLFormElement).elements[0] as HTMLInputElement)
                  .value
            : control.value?.value

        // update url
        router.push({
            query: {
                ...route.query,
                // we have slot
                [props.controlName]: value,
            },
        })
    }
}
</script>
<template>
  <form
    class="search-form d-flex mx-auto position-relative"
    method="GET"
    :action="props.action"
    @submit="handleSubmit"
  >
    <label
      v-if="!hasSlots"
      :for="props.controlName"
      class="visually-hidden"
    >
      {{ props.placeholder }}
    </label>
    <input
      v-if="!hasSlots"
      :id="props.controlName"
      ref="control"
      :value="route.query.query"
      :placeholder="props.placeholder"
      :name="props.controlName"
      type="text"
      class="search-form-control"
    >
    <slot
      v-else
      ref="slot"
    />
    <VButton
      type="submit"
      color="primary"
      class="h-100 flex-shrink-0"
    >
      {{ cta }}
    </VButton>
    <img
      src="~/assets/icons/search.svg"
      width="22"
      height="22"
      class="d-block position-absolute start-0 top-50 translate-middle-y ms-4"
      alt=""
    >
  </form>
</template>
<style scoped lang="scss">
@import './SearchForm.scss';
</style>
